import React, { Component } from "react";
import { connect } from "react-redux";

import { CommonModelImpl } from "../../admin/common/CommonModel";
import SideBar from "../../admin/common/sideBar";
import NoData from "../../admin/common/NoData";

import HeaderAdminpanel from "../common/HeaderAdminpanel";
import http from "../../../util/http";
import { axiosInstnace, getAdminData } from "../../../util/util";
import { endPoints } from "../../../config";
import { getServerDataWithTypes } from "../../../action/common_action";
import { ADMINS_DATA, ANY_ERROR } from "../../../action/user_action_types";
import ViewDSA from "./viewDSA";
import moment from "moment";
import Incentive from "./incentive";
import Map from './Map';
import Pagination from "react-js-pagination";
import { ExcelExport, ExcelExportColumn, } from '@progress/kendo-react-excel-export';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';


class DsaComp extends Component {
  constructor(props) {
    super(props);
    //Set initial state
    this.state = {
      adminData: getAdminData(),
      adminsData: [],
      stationList: [],
      currentDSA: {},
      currentAdmin: "",
      clusterdata: [],
      // clusterdatanametype:"",
      clusterdatanametype: this.props && this.props.location && this.props.location.state && this.props.location.state.tradepartners
      ? this.props.location.state.tradepartners.cluster: "",
      searchName: "",
      status: "",
      showDeletePopup: false,
      showTPDeleteRequest: false,
      showUserCampaigns: false,
      selectedEmail: "",
      campaigns: "",
      msg: "",
      showviewDSAPopup: false,
      page: 1,
      skip: 0,
      limit: 10,
      searchfield: "",
      showMap: false,
      count: 0,
      requestDeleteReason: "",
      exportTradePartnersData: [],
      filterName: ""
    };
  }

  //make a call to fetch admin
  componentDidMount = async () => {
    this.getSearch();
    this.getClusterData()
    this.exportTradePartner();

    // add map script in component to decrease page load time. 
    // this script was included in index.html - i.e: this is loaded in every page
    const script = document.createElement("script");
    script.src = "https://code.highcharts.com/mapdata/countries/in/in-all.js";
    script.async = true;
    document.body.appendChild(script);
  };

  //Set data of admin to state
  componentWillReceiveProps = (nextProps) => {
    let { adminsData } = nextProps;
    if (adminsData) {
      this.setState({
        adminsData: adminsData ? adminsData : [],
      });
    }
  };
  getClusterData = async () => {
    try {
      
      const response = await axiosInstnace.get(`${endPoints.getClusters}`, {
        params: {
          type: "all",
          withoutTradepartnerList: true
        },
      });
      let result = response.data.data.allData;
      result = result
        .map((e) => {
          return e.name;
        })
        .sort();
      if (result) {
        this.setState({
          clusterdata: result,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
  //Making an http request
  serverCalls = async (url, data) => {
    const response = await http.post(url, data);
    if (response && response.data.statusCode == 200) {
      this.componentDidMount();
    } else {
      this.props.showError(
        response ? response.data.message : "Something is wrong"
      );
    }
  };
  // /Delete a admin
  deleteAdmin = () => {
    let { currentAdmin } = this.state;
    let { _id } = currentAdmin;
    let data = { _id };
    this.serverCalls(endPoints.deleteAdmin, data);
    this.setState({
      page: 1,
      currentAdmin: {},
      msg: "",
      showDeletePopup: false,
    });
  };
  //Show hide delete popup
  showHideDeletePopup = (currentAdmin) => {
    let { adminData } = this.state;
    if (currentAdmin && currentAdmin.email == adminData.email) {
      return this.props.showError("You can not delete yourself!");
    }
    this.setState({
      currentAdmin: currentAdmin ? currentAdmin : {},
      msg: currentAdmin ? "Are you sure you want to delete?" : "",
      showDeletePopup: !this.state.showDeletePopup,
    });
  };
  getSearch = async (skipCount = 0) => {
    let url = `${endPoints.getalldsauserspaginated}`;
    let param = {
      mentor:
        this.state.adminData.role !== "admin" &&
        this.state.adminData.role !== "financeAdmin"
          ? this.state.adminData.email
          : "",
      cluster:
        this.state.adminData.role !== "admin" &&
        this.state.adminData.role !== "financeAdmin" &&
        this.state.adminData.role !== "stationAdmin"
          ? this.state.adminData.cluster
          : "",
      search: this.state.searchfield,
      status: this.state.status,
      selectedCluster: this.state.clusterdatanametype,
      skip: skipCount ? skipCount : this.state.skip
    };
    let admins = await axiosInstnace.get(url, {
      params: param,
    });
    const data = await axiosInstnace.get(endPoints.getCityStateRate, {
      params: { limit: false },
    });
    let result = data.data.data.data;
    debugger;
    this.setState({
      stationList: result.map((e) => e.station),
      adminsData: admins.data.data.data,
      count: admins.data.data.count
    });
  };

  viewDSADetails = async (dsa) => {
    this.setState({
      currentDSA: dsa,
      showviewDSAPopup: true,
    });
  };

  toggleDeleteRequestModal = (tpEmail = undefined) => {
    let { adminData } = this.state;
    if(tpEmail){
      if (tpEmail == adminData.email) {
        return this.props.showError("You can not delete yourself!");
      }else{
        this.setState({
          currentAdmin: tpEmail,
          showTPDeleteRequest: !this.state.showTPDeleteRequest,
        });
      }
    }else{
      this.setState({
        showTPDeleteRequest: !this.state.showTPDeleteRequest,
      });
    }
  };
  
  submitDeleteTPRequest = async () => {
    if(this.state.requestDeleteReason){
      let { currentAdmin, adminData, requestDeleteReason } = this.state;
      if (currentAdmin.email == adminData.email) {
        return this.props.showError("You can not delete yourself!");
      }
      const deleteRequestResult = await axiosInstnace.post(endPoints.deleteTPRequest, {
          email: currentAdmin, deleteReason: requestDeleteReason ,
        }
      );
  
      if(deleteRequestResult.data){
        let adminsData = this.state.adminsData.filter(tradePartner=> tradePartner.email != this.state.currentAdmin);
  
        this.setState({
          adminsData: adminsData,
          showTPDeleteRequest: !this.state.showTPDeleteRequest,
        });
      } 
    }else{
      this.props.showError("Enter reason for trade partner delete request");
    }
  };

  //Admin logout
  logout = () => {
    localStorage.removeItem("adminInfo");
    window.location.href = "/admin/login";
  };

  hideshowuserCampaigns = () => {
    this.setState({
      showUserCampaigns: !this.state.showUserCampaigns,
    });
  };

  handlePageChange = (page) => {
    let skipCount = 10 * ( page - 1);
    this.setState({
      skip: skipCount,
      page: page
    });
    this.getSearch(skipCount);
  }

  exportTradePartner = async () => {
    let url = `${endPoints.exportDSA}`;
    let param = {
      mentor:
        this.state.adminData.role !== "admin" &&
        this.state.adminData.role !== "financeAdmin"
          ? this.state.adminData.email
          : "",
      cluster:
        this.state.adminData.role !== "admin" &&
        this.state.adminData.role !== "financeAdmin" &&
        this.state.adminData.role !== "stationAdmin"
          ? this.state.adminData.cluster
          : "",
      search: this.state.searchfield,
      status: this.state.status,
      selectedCluster: this.state.clusterdatanametype,
    };
    let response = await axiosInstnace.get(url, {
      params: param,
    });

    if (response && response.data.statusCode == 200) {
      let filtersApplied = '';
      filtersApplied += param.status ? `Status: ${param.status == "null" ? "Pending": param.status}`: '';
      filtersApplied += param.search ? `  Search: ${param.search}`: '';
      filtersApplied += param.cluster ? `  Default Cluster: ${param.cluster}`: '';
      filtersApplied += param.selectedCluster ? `  Selected Cluster: ${param.selectedCluster}`: '';
      

      this.setState({ 
        exportTradePartnersData: response.data.data,
        filterName: filtersApplied
      })
    }
  }

  render() {
    let {
      adminsData,
      adminData,
      searchName,
      showDeletePopup,
      showTPDeleteRequest,
      msg,
      skip,
      page,
      count,
      showAddAdminPopup,
      exportTradePartnersData,
    } = this.state;
    return (
      <div>
        {!this.state.showviewDSAPopup && !this.state.showUserCampaigns && (
          <div className="dashboardContainer">
            <HeaderAdminpanel />
            <div className="dashboardContainer-inner">
              <section id="sidebar">
                <SideBar parent="0" child="0" />
              </section>
              <section
                id="dashboard-rightContainer"
                className="dashboard-manageSales"
              >
                <div className="container-head">
                  <div className="dashboard-breadcrumb">
                    Trade Partner Management |
                    <span className="breadcrumb-active advertiser-breadcrumb">
                      Trade Partner List
                    </span>
                  </div>
                  <div className="status-input search_camp search_list">
                    { this.state.showMap && (
                      <button onClick={(e)=> {
                        this.setState({ showMap: false })
                      }} style={{color: "white"}}>Show Trade Partner List</button>
                    )}
                    { !this.state.showMap && (
                      <button onClick={(e)=> {
                        this.setState({ showMap: true })
                      }} style={{color: "white"}}>Show Tradepartner Coverage</button>
                    )}
                    
                  </div>
                  <div class="status-input search_camp search_list">  
                    <select
                      class="packageType drop-down-icon status-dropdown"
                      onChange={async (e) => {
                        this.setState(
                          {
                            status: e.target.value,
                          },
                          () => {this.getSearch(); this.exportTradePartner();}
                        );
                      }}
                    >
                      <option value="">Choose Status</option>
                      <option value="Submitted">Submitted</option>
                      <option value="null">Pending</option>
                      <option value="Verified">Verified</option>
                      <option value="Rejected">Rejected</option>
                    </select>
                  </div>
                  <div className="status-input search_camp search_list">
                    <select
                      className="packageType drop-down-icon"
                      value={this.state.clusterdatanametype}
                      onChange={(e) => {
                        this.setState({
                          clusterdatanametype: e.target.value,
                        }, ()=> {this.getSearch(); this.exportTradePartner();});
                      }}
                    >
                      <option value="" disabled selected>
                        {" "}
                        Choose ClusterName{" "}
                      </option>{" "}
                      {this.state.clusterdata.map((cluster) => (
                        <option> {cluster} </option>
                      ))}{" "}
                    </select>{" "}
                  </div>
                  <div
                    className="search_camp"
                  >
                    <input
                      type="text"
                      placeholder="search"
                      ref={this.state.searchfield}
                      onChange={(e) => {
                        this.setState(
                          {
                            searchfield: e.target.value,
                          },
                          () => {this.getSearch(); this.exportTradePartner();}
                        );
                      }}
                    />
                    <span>
                      <img src="/assets/images/search.png" />
                    </span>
                  </div>
                </div>

                <div
                  className={
                    adminsData.length === 0
                      ? "dashboard-content userListing-dashboard bg-white table-responsive none"
                      : "dashboard-content userListing-dashboard bg-white table-responsive"
                  }
                >
                  {/* <button onClick={(e)=> {
                      this.exportTradePartner()
                    }} style={{color: "white", margin: "20px",float: "right"}}>Export Trade Partners</button> */}

                <ReactHTMLTableToExcel
                  id="test-table-xls-button"
                  className="download-table-xls-button"
                  table="trade-partner-export"
                  filename="trade-partners"
                  buttonText="Export Trade Partners" />

                  {!this.state.showUserCampaigns && !this.state.showMap && (
                    <table className="table table-striped master-table">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>City</th>
                          <th>Mobile</th>
                          <th>Last Update</th>
                          <th>Registration date</th>
                          <th>Last Login</th>
                          <th>Total Campaigns</th>
                          <th>Base Station</th>
                          <th>Status</th>
                          <th className="txt-cntr">Actions</th>
                          <th>Email</th>
                          <th>Mentor ID</th>
                        </tr>
                      </thead>
                      <tbody>
                        {adminsData.map((data, index) => {
                          return (
                            <tr key={index}>
                              <td>{data.name}</td>
                              <td>{data.city}</td>
                              <td>{data.mobile}</td>

                              <td>
                                {data.previousKycStatuses &&
                                  data.previousKycStatuses.length > 0 && (
                                    <span>
                                      {moment(
                                        data.previousKycStatuses[
                                          data.previousKycStatuses.length - 1
                                        ].time
                                      ).format("DD/MM/YYYY hh:mm A")}
                                    </span>
                                  )}
                                {data.previousKycStatuses &&
                                  data.previousKycStatuses.length == 0 && (
                                    <span>NA</span>
                                  )}
                              </td>
                              <td>
                                {data.joiningdate && (
                                  <span>
                                    {moment(data.joiningdate).format(
                                      "DD/MM/YYYY hh:mm A"
                                    )}
                                  </span>
                                )}
                                {!data.joiningdate && <span>NA</span>}
                              </td>

                              <td>
                                {data.lastLogin && (
                                  <span>
                                    {moment(data.lastLogin).format(
                                      "DD/MM/YYYY hh:mm A"
                                    )}
                                  </span>
                                )}
                                {!data.lastLogin && <span>NA</span>}
                              </td>
                              <td
                                style={{ cursor: "pointer" }}
                                onClick={(e) => {
                                  this.setState({
                                    showUserCampaigns: true,
                                    campaigns: data.usercampaigns,
                                    selectedEmail: data.email,
                                  });
                                }}
                              >
                                {data.usercampaigns && data.usercampaigns}
                              </td>
                              <td>{data.station}</td>
                              <td
                                style={{
                                  color:
                                    data.kycstatus &&
                                    data.kycstatus.status === "Verified"
                                      ? "#97b911"
                                      : data.kycstatus &&
                                        data.kycstatus.status === "Rejected"
                                      ? "red"
                                      : data.kycstatus &&
                                        data.kycstatus.status === "Submitted"
                                      ? "blue"
                                      : "orange",
                                }}
                              >
                                {data.kycstatus && data.kycstatus.status
                                  ? data.kycstatus.status
                                  : "Pending"}
                              </td>

                              <td className="txt-cntr">
                                <a>
                                  <span className="tooltip-reject view-tooltip">
                                    <img
                                      src="/assets/images/eye.png"
                                      className="reject-approved-img reject-png"
                                      onClick={() => {
                                        this.viewDSADetails(data);
                                      }}
                                    />
                                    <span>View</span>
                                  </span>
                                </a>
                                {/* {(!data.kycstatus ||
                                  !data.kycstatus.status ||
                                  data.kycstatus.status === "Pending") &&
                                  this.state.adminData.role === "admin" && (
                                    <a>
                                      <span className="tooltip-reject">
                                        <img
                                          src="/assets/images/delete.png"
                                          className="reject-approved-img reject-png"
                                          onClick={() =>
                                            this.showHideDeletePopup(data)
                                          }
                                        />
                                        <span>Delete</span>
                                      </span>
                                    </a>
                                )} */}
                                { (!data.kycstatus ||
                                  !data.kycstatus.status ||
                                  (data.kycstatus.status === "Pending" || (data.kycstatus.status === "Rejected" && moment.duration(moment().diff( moment(data.kycstatus.time) )).asDays() > 30 ))) && (this.state.adminData.role === "salesUser" || this.state.adminData.role === "admin") && (
                                    <a>
                                      <span className="tooltip-reject">
                                        <img
                                          src="/assets/images/delete.png"
                                          className="reject-approved-img reject-png"
                                          onClick={() =>
                                            this.toggleDeleteRequestModal(data.email)
                                          }
                                        />
                                        <span>Delete</span>
                                      </span>
                                    </a>
                                )}
                              </td>
                              <td>{data.email}</td>
                              <td>{data.mentorID}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  )}

                {(count > 10) && (
                <div className="paginationTable">
                  <div className="pagination-wrapper">
                    <div className="dataTables_paginate paging_full_numbers" id="advertiser-details_paginate">
                      <Pagination
                        prevPageText='Prev'
                        nextPageText='Next'
                        firstPageText='First'
                        lastPageText='Last'
                        activePage={page}
                        itemsCountPerPage={10}
                        totalItemsCount={count}
                        onChange={this.handlePageChange}
                      />
                    </div>
                  </div>
                </div>)}

                  
                  
                  { this.state.showMap && (
                    <Map dsadata={this.state.adminsData} />
                  )}

                  <div className="paginationTable" />
                  {/* {(skip > 0 || totalRecord > 10) &&
                  <Pagination getAllData={this.getAllData} totalRecords={totalRecord} />
                } */}
                </div>
                {adminsData.length === 0 ? <NoData /> : null}
              </section>
            </div>
          </div>
        )}
        {this.state.showviewDSAPopup && (
          <ViewDSA
            dsa={this.state.currentDSA}
            stationlist={this.state.stationList}
          />
        )}
        {this.state.showUserCampaigns && (
          <Incentive
            email={this.state.selectedEmail}
            hide={this.hideshowuserCampaigns}
          />
        )}
        {showDeletePopup && (
          <CommonModelImpl
            headerMsg={"Trade Partner Delete"}
            msg={msg}
            okButtonShow={true}
            okButtonText={"PROCEED"}
            okAction={this.deleteAdmin}
            cancelButtonShow={true}
            cancelButtonText={"No"}
            cancelAction={this.showHideDeletePopup}
          />
        )}

        { showTPDeleteRequest && (
          <div className="modal-overlay">
            <div
              className="modal-wrapper thankyou-popup"
              aria-modal
              aria-hidden
              tabIndex={-1}
              role="dialog"
            >
              <div className="modal approval">
                <div className="modal-head-cross rate-modal">
                  <button
                    type="button"
                    className="modal-close-button"
                    onClick={ (e) => { this.toggleDeleteRequestModal() }}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="editNonFct-header modal-header">
                    <h4 className="rqst-head fct-head modal-title">
                      Reason for deletion
                    </h4>

                    <textarea placeholder="Enter reason for trade partner delete request" rows="4" style={{ padding: "5px", margin: "5px 0px", width: "100%", border: "1px solid #94aeca", borderRadius: "5px" }} onChange={ (e)=> { this.setState({requestDeleteReason: e.target.value}) }}></textarea>

                    <button style={{float: "right", padding: "5px", color: "white"}} onClick={this.submitDeleteTPRequest}>Submit</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* <ExcelExport
          data={exportTradePartnersData}
          fileName="trade-partners.xlsx"
          ref={(exporter) => { this._exporter = exporter; }}
        >
          <ExcelExportColumn field="name" title="Name" />
          <ExcelExportColumn field="email" title="Email" />
          <ExcelExportColumn field="mobile" title="Mobile number" />
          <ExcelExportColumn field="status" title="Status" />
          <ExcelExportColumn field="usercampaigns" title="Total Campaigns" />
          

        </ExcelExport> */}

          <table id="trade-partner-export" className="table table-striped master-table" style={{display: "none"}}>
            <thead>
              <tr>
                <th colSpan="10">{this.state.filterName}</th>
              </tr>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Mobile number</th>
                <th>City</th>
                <th>Registration Date</th>
                <th>Last login</th>
                <th>Base Station</th>
                <th>Mentor ID</th>
                <th>Status</th>
                <th>Total Campaigns</th>
              </tr>
            </thead>
            <tbody>
            {exportTradePartnersData.map((tradePartner, index) => (
              <tr>
                <td>{ tradePartner.name }</td>
                <td>{ tradePartner.email }</td>
                <td>{ tradePartner.mobile }</td>
                <td>{ tradePartner.city }</td>
                <td>{ moment(tradePartner.joiningdate).format( "DD/MM/YYYY" ) }</td>
                <td>{ moment(tradePartner.lastLogin).format( "DD/MM/YYYY hh:mm A" ) }</td>
                <td>{ tradePartner.station }</td>
                <td>{ tradePartner.mentorID }</td>
                <td>{ tradePartner.status }</td>
                <td>{ tradePartner.usercampaigns }</td>
              </tr>
            ) )}
              
            </tbody>
          </table>
      </div>

      
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminsData: state.user.get("adminsData"),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminsData: (url, type) => dispatch(getServerDataWithTypes(url, type)),
    showError: (error) =>
      dispatch({
        type: ANY_ERROR,
        payload: error,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DsaComp);



// WEBPACK FOOTER //
// ./web/components/admin/dsa_management/index.js